import React, { useEffect, useState } from "react";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import ClientsTable from "../components/ClientsTable";
import clientsService from "../../../services/clientsService";
import DashboardLayout from "../../../layouts/DashboardLayout";

const ClientsPage = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const data = await clientsService.getClients();
        setClients(data);
      } catch (error) {
        console.error("Error al obtener clientes:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchClients();
  }, []);

  return (
    <DashboardLayout>
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Gestión de Clientes
        </Typography>
        <Button variant="contained" color="primary">
          Registrar Cliente
        </Button>
        {loading ? <CircularProgress /> : <ClientsTable clients={clients} />}
      </Box>
    </DashboardLayout>
  );
};

export default ClientsPage;
